import styled from "styled-components";
import { colors, typeface } from "@sonder/ui/source/styled/theme";

type BadgeColor = "gray" | "red" | "orange" | "yellow" | undefined;
const getPrimaryColor = (color: BadgeColor) => {
  if (color === "red") return colors.redD;
  if (color === "orange") return colors.orangeD;
  if (color === "yellow") return colors.yellow;
  if (color === "gray") return colors.gray6;
  return colors.white;
};
interface BadgeProps {
  color?: BadgeColor;
}
export const Badge = styled.span<BadgeProps>`
  background: ${props => getPrimaryColor(props.color)};
  border: 1px solid
    ${props => (props.color ? getPrimaryColor(props.color) : "currentColor")};
  border-radius: 0.2rem;
  box-sizing: border-box;
  color: ${props => (props.color ? colors.white : "inherit")};
  display: inline-flex;
  font-family: ${typeface.primary};
  font-weight: ${props => props.color && "bold"};
  font-size: 0.75rem;
  justify-content: center;
  line-height: 1.5rem;
  min-width: 1.7rem;
  padding: 0 5px;
  user-select: none;
`;
